module.exports = __webpack_public_path__ + "img/12.60cc9b57.png";